/**
 * ============================================================
 *
 * [content]
 * 
 * ============================================================
 */

/* ハンバーガーメニュー */
var navState = {
    isNavOpen: false,
    scrollY: 0
};

$('#gNavOpener').on('click', function () {
    if (navState.isNavOpen) {
        // ====== ナビを閉じる ======
        $('#gNavOpener, body').removeClass('open');
        $('body').css({
            position: '',
            top: '',
            width: ''
        });
        // 元の位置に戻す
        window.scrollTo(0, navState.scrollY);
        navState.isNavOpen = false;
    } else {
        // ====== ナビを開く ======
        navState.scrollY = window.scrollY;
        $('body').css({
            position: 'fixed',
            top: -navState.scrollY + 'px',
            width: '100%'
        });
        $('#gNavOpener, body').addClass('open');
        navState.isNavOpen = true;
    }
});

/* グローバルナビのリンククリック時（ページ内リンク用） */
$('header .inner ul a').on('click', function (e) {
    var href = $(this).attr('href');

    // href が # で始まらない → 外部リンクなどは何もしない
    if (!href || href.charAt(0) !== '#') {
        return;
    }

    // ページ内リンクなのでブラウザ標準の動作を止める
    e.preventDefault();

    var $target = $(href);
    if ($target.length === 0) {
        return;
    }

    // 1. ハンバーガーを閉じる（スクロール位置はここでは復元しない）
    if (navState.isNavOpen) {
        $('#gNavOpener, body').removeClass('open');
        $('body').css({
            position: '',
            top: '',
            width: ''
        });
        navState.isNavOpen = false;
    }

    // 2. ヘッダー高さを考慮してスクロール
    var headerHeight = $('header').outerHeight() || 0;
    var targetTop = $target.offset().top - headerHeight;

    window.scrollTo({
        top: targetTop,
        behavior: 'smooth'  // なめらかスクロール（不要なら削除）
    });
});

/* スクロール 判定 */
document.addEventListener('DOMContentLoaded', function () {
    const body = document.body;

    window.addEventListener('scroll', function () {
        if (window.scrollY > 200) {
            body.classList.add('scroll_show');
        } else {
            body.classList.remove('scroll_show');
        }
    })
});

/* アンカーリンク */
$(function () {
    $('a[href^="#"]').click(function () {
        var speed = 400;
        var href = $(this).attr("href");
        var target = $(href === "#" || href === "" ? 'html' : href);
        
        // 対象要素が存在しない場合は何もしない
        if (!target.length) return false;
        
        var position = target.offset().top;
        $('html, body').animate({ scrollTop: position }, speed, 'swing');
        return false;
    });
});

/* 要素が画面内に入っているか判定してclass付与 */
document.addEventListener('DOMContentLoaded', () => {
    const targets = Array.from(document.querySelectorAll('.js_observe'));
    if (!targets.length) return;

    const headerH = document.querySelector('header')?.offsetHeight || 0;
    const ratios = new Map();
    let activeEl = null;

    // スクロール方向判定用
    let lastScrollY = window.scrollY;

    const observer = new IntersectionObserver((entries) => {
        const currentScrollY = window.scrollY;
        const isScrollingDown = currentScrollY > lastScrollY;
        lastScrollY = currentScrollY;

        entries.forEach(entry => {
            ratios.set(entry.target, entry.intersectionRatio);
        });

        let mostVisible = null;
        let maxRatio = 0;

        targets.forEach(el => {
            const r = ratios.get(el) || 0;
            if (r > maxRatio) {
                maxRatio = r;
                mostVisible = el;
            }
        });

        if (mostVisible && maxRatio > 0) {

            if (mostVisible !== activeEl) {

                // ==========================
                // アクティブ解除
                // ==========================
                if (activeEl) {
                    activeEl.classList.remove('show_element');

                    if (activeEl.id) {
                        document.body.classList.remove(`is-${activeEl.id}`);

                        // ✅ 下スクロール時のみ after を付与
                        if (isScrollingDown) {
                            document.body.classList.add(`is-after-${activeEl.id}`);
                        }
                    }
                }

                // ==========================
                // アクティブ設定
                // ==========================
                mostVisible.classList.add('show_element');

                if (mostVisible.id) {
                    document.body.classList.add(`is-${mostVisible.id}`);

                    // 再び見えたら after は必ず解除
                    document.body.classList.remove(`is-after-${mostVisible.id}`);
                }

                activeEl = mostVisible;
            }

        } else {
            // どれも見えていない場合
            if (activeEl && activeEl.id) {
                activeEl.classList.remove('show_element');
                document.body.classList.remove(`is-${activeEl.id}`);
                activeEl = null;
            }
        }

    }, {
        rootMargin: `-${headerH}px 0px 0px 0px`,
        threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    targets.forEach(el => {
        ratios.set(el, 0);
        observer.observe(el);
    });
});

/* 下層ページ header 分たけ title_area の位置調整 */
document.addEventListener("DOMContentLoaded", () => {
    const setHeaderHeight = () => {
        if (!document.body.classList.contains("lower_page")) return;

        const headerInner = document.querySelector("header .inner");
        if (!headerInner) return;

        requestAnimationFrame(() => {
            const h = headerInner.getBoundingClientRect().height;
            if (h > 0) {
                document.documentElement.style.setProperty(
                    "--header-h",
                    h + "px"
                );
            }
        });
    };

    setHeaderHeight();

    window.addEventListener("load", setHeaderHeight);
    window.addEventListener("resize", setHeaderHeight);
    document.addEventListener("shopify:section:load", setHeaderHeight);
});